import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PlaylistDto } from '../../../core/models/api.models';

@Component({
  selector: 'app-playlist-card',
  templateUrl: './playlist-card.component.html',
  styleUrls: ['./playlist-card.component.scss']
})
export class PlaylistCardComponent {
  @Input() playlist!: PlaylistDto;
  @Output() delete = new EventEmitter<string>();

  platformLabel(platform?: string): string {
    const key = (platform || '').toLowerCase();
    const map: Record<string, string> = {
      spotify: 'Spotify',
      youtube: 'YouTube',
      'youtube music': 'YouTube Music',
      ytmusic: 'YouTube Music'
    };
    return map[key] || (platform ? platform : '—');
  }

  isSpotify(platform?: string): boolean {
    const key = (platform || '').toLowerCase();
    return key === 'spotify';
  }

  isYoutube(platform?: string): boolean {
    const key = (platform || '').toLowerCase();
    return key === 'youtube' || key === 'youtube music' || key === 'ytmusic';
  }
}
